import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'
import { delay } from 'utils/Delay'

const name = 'BF-ANIMATION'

async function execute() {
  const spinModel = game.models.SpinModel.get()
  const modeModel =  game.models.ModeModel
  if(time.baseFeature && spinModel.respin.length && modeModel.respinIntro){
    modeModel.respinIntro = false
    signal.dispatch('RESPIN-INTRO-ANIM')
    return  delay(time.baseFeature)
  }
  else{
    return Promise.resolve()
  }

}

export function getRespinIntroAction() {
  return {
    name,
    execute,
  }
}
